import React, { useState } from 'react';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { SerializedError } from '@reduxjs/toolkit';
import { convertToError } from '../../API/BaseApi';
import { ErrorBanner } from './components/ErrorBanner';
import { Show } from '../../components/shared/Show';
import { BodyTextTW } from '../bodyText/BodyTextTW';
import { StackTraceTW } from './components/StackTraceTW';
import { StackTraceInfoButtonTW } from './components/StackTraceInfoButton';
import type { FCWithChildren } from '../../types/FCWithChildren';

export interface IErrorMessageTWProps extends IHasTestData {
  error?: Error;
  message?: React.ReactNode;
  rtkError?: FetchBaseQueryError | SerializedError;
  children?: React.ReactNode;
}

export const ErrorMessageTW: FCWithChildren<IErrorMessageTWProps> = ({ children, error, rtkError, message }) => {
  const [showStackTrace, setShowStackTrace] = useState<boolean>(false);
  const err: Error | undefined = convertToError(rtkError) ?? error;

  if (!children && !err && !message) {
    return null;
  }

  return (
    <ErrorBanner>
      <Show when={!!message}>
        <BodyTextTW>{message}</BodyTextTW>
      </Show>
      {children}
      <Show when={!!err}>
        <StackTraceInfoButtonTW onClick={() => setShowStackTrace((prevState) => !prevState)} />
        <p>{err?.message}</p>
      </Show>
      <Show when={showStackTrace}>
        <StackTraceTW>{err?.stack}</StackTraceTW>
      </Show>
    </ErrorBanner>
  );
};
